export default __webpack_public_path__ + "static/media/theme-placeholder.d11959ad.png";